import React, { Fragment, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter, matchPath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Divider from '@material-ui/core/Divider';
import AuthorizationContext from '../../contexts/AuthorizationContext';
import MobileContext from '../../contexts/MobileContext';
import UserMenu from './user-menu/UserMenu';
import AppMenu from './application-menu/Menu';
import useStyles from './HeaderStyle';
import PublicContext from '../../contexts/PublicContext';
import MediaLinks from './media-links/MediaLinks';
import CandidatesSearchComponent from './candidates-search/CandidatesSearchComponent';
import { employerPositionsPath } from '../../application/ApplicationRoutes';
import EmployerContext from '../../contexts/EmployerContext';
import { RoutePaths } from '../../constants/RoutePaths';

export const positionPaths = /employer\/\w{24}\/position\/\w{24}\//;

const checkIfHasSubHeader = () => {
    const { pathname } = window.location;

    const subHeadersPaths = [
        positionPaths,
        /employer\/\w{24}\/diversityReport/,
    ];

    const excludedRoutes = [
        /employer\/\w{24}\/position\/\w{24}\/wizard\/preliminaryFeedback\/v2/,
        /employer\/\w{24}\/position\/\w{24}\/wizard\/suggestions/,
        /employer\/\w{24}\/position\/\w{24}\/wizard\/instantRating/,
    ];

    return subHeadersPaths.some((pathRegex) => pathRegex.test(pathname)) && !excludedRoutes.some((pathRegex) => pathRegex.test(pathname));
};

// Modified by AI on 05/14/2026. Edit #2.
const Header = (props) => {
    const {
        user, isTalenyaUser, isTalentExpertUser, isEmployerRepAdmin,
    } = useContext(AuthorizationContext);
    const { isMobile } = useContext(MobileContext);
    const isPublicMode = useContext(PublicContext);
    const { employer } = useContext(EmployerContext);
    const hasSubheader = checkIfHasSubHeader();

    const isManualQualifyPage = !!matchPath(
        props.location.pathname,
        RoutePaths.manualQualify,
    );

    const classes = useStyles({
        isMobile, isPublicMode, hasSubheader, isManualQualifyPage,
    });

    const { t } = useTranslation();

    const isJobListPage = !!matchPath(
        props.location.pathname,
        employerPositionsPath,
    );

    const isInactiveUserPage = !!matchPath(
        props.location.pathname,
        '/inactive-user-page',
    );

    const isLoginPage = !!matchPath(
        props.location.pathname,
        '/login',
    );

    const isOnlyFastRatingAllowed = useMemo(() => employer?.settings?.isOnlyFastRatingAllowed, [employer, isTalenyaUser]);

    const isMenuHidden = (isLoginPage || (isOnlyFastRatingAllowed && !isTalenyaUser && !isTalentExpertUser && !isEmployerRepAdmin));
    const shouldRenderNavigation = !isPublicMode && user && !isInactiveUserPage;

    return (
        <div className={classes.root}>
            <div className={classes.body}>
                { (shouldRenderNavigation || isLoginPage) && <div className={classes.leftSide}>
                    <AppMenu isMenuHidden={isMenuHidden}/>
                    { !isLoginPage && isJobListPage && employer?.settings?.isResellerPartner && <h3 className={classes.marginLeft}>
                        { t(employer?.office || '') || '' }
                    </h3>
                    }
                </div>
                }
                { shouldRenderNavigation && <div className={classes.rightSide}>
                    { isJobListPage && <Fragment>
                        <CandidatesSearchComponent className={classes.mediaLinks}/>
                        <Divider orientation="vertical" style={{ height: 36, margin: '0 20px' }}/>
                    </Fragment>
                    }
                    { !isOnlyFastRatingAllowed && <MediaLinks className={classes.mediaLinks}/> }
                    <UserMenu
                        isMenuHidden={isOnlyFastRatingAllowed && !isTalenyaUser && !isTalentExpertUser && !isEmployerRepAdmin}
                        className={classes.userMenu}
                    />
                </div>
                }
            </div>
        </div>
    );
};

Header.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
};

export default withRouter(Header);
